<span
  class="badge {{ type }} {{ !!icon ? 'badge--with-icon' : '' }}"
  [class.analyst-studio]="isAnalystStudio && type === 'green'"
>
  <capra-icon *ngIf="icon" [icon]="icon"></capra-icon>
  <span>
    {{ text }}
  </span>
</span>
